module.exports = __webpack_public_path__ + "img/redatlas.d0fb53fa.png";